<template>
    <div class="page-login">
        <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="用户名" prop="username">
                <el-input v-model="ruleForm.username"></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="password">
                <el-input v-model="ruleForm.password" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="password2">
                <el-input v-model="ruleForm.password2" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
                <el-button @click="resetForm('ruleForm')">重置</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    import { register } from '@/api/user.js';
    export default {
        data() {
            return {
                ruleForm: {
                    username: "",
                    password: ""
                },
                rules: {
                    username: [{
                        required: true,
                        message: '请输入用户名x',
                        trigger: 'blur'
                    }],
                    password: [{
                        required: true,
                        message: '请输入密码',
                        trigger: 'blur'
                    }],
                    password2: [{
                        required: true,
                        message: '请输入确认密码',
                        trigger: 'blur'
                    }]
                }
            }
        },
        methods: {
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        register(this.ruleForm.username,this.ruleForm.password,this.ruleForm.password2).then((response)=>{
                            console.log(response)
                            if (response.data.code == 200) {
                                this.$message.success(response.data.msg);
                            }else {
                                this.$message.error(response.data.msg);
                            }
                        })
                    } else {
                        return false;
                    }
                });
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            }
        }
    }
</script>

<style lang="scss">
    .page-login {
        width: 600px;
        margin: 100px auto 0;
    }
</style>



// WEBPACK FOOTER //
// src/components/register/index.vue